/**
 * @generated SignedSource<<87c983e7d58536704f4c5052fc0cc4ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersSectionMenuQuery$data = {
  readonly articleSearchV2: {
    readonly aggregations: {
      readonly section: {
        readonly buckets: ReadonlyArray<{
          readonly doc_count: number;
          readonly key: string;
        }>;
      };
    };
  } | null | undefined;
  readonly " $fragmentType": "helpersSectionMenuQuery";
};
export type helpersSectionMenuQuery$key = {
  readonly " $data"?: helpersSectionMenuQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersSectionMenuQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersSectionMenuQuery"
};

(node as any).hash = "7efd3288b7b227f17798408a7b0d1685";

export default node;
